import { SignupInputFieldName } from "@finbackoffice/enums";
import {
    LETTERS_OR_DIGITS_WITHOUT_UPPER_LETTERS,
    LETTERS_OR_DIGITS,
    SignupConfigType,
} from "@finbackoffice/fe-core";
import { useContext, useMemo } from "react";
import { ConfigContextV2 } from "contexts";
import { useSiteConfig } from "@finbackoffice/site-core";
import useSkinVersion from "./useSkinVersion";

export const useSignupConfigV2 = (fields?: SignupInputFieldName[]) => {
    const siteSignupFieldsConfig = useSiteConfig<SignupConfigType[]>("signupFields");
    const { siteRegistrationConfig } = useContext(ConfigContextV2);
    const { isBrazilianSkin, isBettorian } = useSkinVersion();

    const signupConfig = useMemo(
        () =>
            siteSignupFieldsConfig?.filter(
                (field) => field.enable && (fields ? fields.includes(field.name) : true),
            ),
        [fields, siteSignupFieldsConfig],
    );

    const signupConfigObj = useMemo(() => {
        const result: Partial<Record<SignupInputFieldName, SignupConfigType>> = {};

        signupConfig?.forEach((item) => {
            if (item.name === SignupInputFieldName.Password) {
                item = {
                    ...item,
                    has_digit: siteRegistrationConfig?.password_has_digit || false,
                    has_letter: siteRegistrationConfig?.password_has_letter || false,
                };
            }
            if (
                item.name === SignupInputFieldName.Username ||
                item.name === SignupInputFieldName.Referral
            ) {
                item = {
                    ...item,
                    dynamic_regexp:
                        isBrazilianSkin || isBettorian
                            ? LETTERS_OR_DIGITS
                            : LETTERS_OR_DIGITS_WITHOUT_UPPER_LETTERS,
                };
            }
            if (item.enable && (fields ? fields.includes(item.name) : true)) {
                result[item.name] = item;
            }
        });

        return result;
    }, [
        fields,
        isBettorian,
        isBrazilianSkin,
        signupConfig,
        siteRegistrationConfig?.password_has_digit,
        siteRegistrationConfig?.password_has_letter,
    ]);

    return { signupConfigObj, signupConfig };
};
